var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"scroll-left-box"},[_c('div',{staticClass:"scroll-top-box"},[(_vm.contList && _vm.contList.length)?_c('ul',{staticClass:"scroll-tip"},_vm._l((_vm.contList),function(item,index){return _c('li',[_c('span',[_vm._v(_vm._s(index + 1))]),_vm._v(_vm._s(item.txt))])}),0):_vm._e()])])
}
var staticRenderFns = []

export { render, staticRenderFns }